import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Grid2";
import { useGetPharmaciesQuery } from "src/api/services/pharmacyApi";
import PharmacyToggle from "./components/PharmacyToggle";

const Pharmacies = () => {
  const { data: pharmacies = [] } = useGetPharmaciesQuery();

  return (
    <Box mr={10}>
      <Grid2 container rowSpacing={2} columnSpacing={10}>
        {pharmacies?.map((ph) => (
          <PharmacyToggle key={ph.id} pharmacy={ph} />
        ))}
      </Grid2>
    </Box>
  );
};

export default Pharmacies;
